<mat-card appearance="outlined">
  <mat-icon class="close-button" (click)="onCloseClick()">close</mat-icon>
  <div class="title-container">
    <mat-icon class="title-icon">cloud_upload</mat-icon>
    <p class="title-text">Upload Pictures</p>
  </div>
  <p class="subtitle-text">
    Allowed formats: {{ fileUploadOptions.allowedExtensions.join(", ") }}. Max
    picture size, {{ fileUploadOptions.maxSizeAllowedPerFileInMB }}Mb. Max
    {{ fileUploadOptions.maxAllowedFiles }} pictures in a single upload.
  </p>
  <cotecna-file-upload
    id="fileUploadComponent"
    [options]="fileUploadOptions"
    (filesSelected)="onFilesSelected($event)"
    (onInteractionWithComponent)="onInteractionWithComponent()"
    (warningsDetected)="onWarningDetected($event)"
    >
  </cotecna-file-upload>

  <table width="100%">
    @if (showComponentError) {
      <p
        class="component-error"
        [innerHTML]="componentErrorText"
      ></p>
    }
    <tr class="button-container">
      @if (readyLoading) {
        <div>
          <button id="cancel-file-upload" (click)="cancel()" mat-button>
            CANCEL
          </button>
          <button
            id="submit-files"
            [disabled]="submitButtonDisabled"
            (click)="submit()"
            mat-button
            >
            UPLOAD FILES
          </button>
        </div>
      } @else {
        <mat-spinner class="loading-spinner" diameter="32"></mat-spinner>
      }
    </tr>
  </table>

</mat-card>
